<template>
  <div id="serp-container" class="bg-white pt-5">
    <div v-if="loading">
      <div class="flex flex-wrap justify-center max-w-5xl mx-auto">
        <div class="card w-80" v-for="i in [1,2,3,4,5,6]">
          <div class="card bg-base-100 image-full  shadow-xl m-3">
            <div class="skeleton w-full" style="height: 166px"></div>
          </div>
          <div class="card-body p-3">
            <div class="skeleton h-4 w-28"></div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="max-w-5xl mx-auto">
      <h1 class="text-2xl pb-8 font-thin" v-if="results.length">
        Ecco una lista di organizzazioni che questo Natale cercano una collaborazione con aziende per generare impatto
        sociale
      </h1>
      <div class="flex flex-wrap justify-center" v-if="results.length">
        <ui-onp-card :record="record" v-for="record in results" @record:open="openRecord"/>
      </div>
      <div v-else class="container mx-auto text-center p-5">
        <h1>Non abbiamo trovato nessun ente!</h1>
      </div>
    </div>

    <ui-modal ref="dialog" @dismiss="isOpen = false" class="p-0">
      <template #body>
        <NuxtPage/>
      </template>
    </ui-modal>
    <template-disclaimer/>
  </div>


</template>
<script setup lang="ts">
const {getOnpForCompany} = useRecords();
const loading = ref(true);
const isOpen = ref(false);
const dialog = ref();
import type {ONPRecord} from "~/types/record";

// Personalizzazioni di layout
const navbarType = inject('navbarType')
navbarType.value = 'light';

// SEO
useSeoMeta({
  title: 'Opportunità per tutte le Aziende',
  description: 'Quali vantaggi ha un\'azienda che attiva iniziative solidali? Si tratta di un\'opportunità solo per le grandi imprese o per tutte le realtà? Scopri di più.',
  image: 'https://onp.app/seo/aziende.jpg'
})

// Gestione SERP
const results = ref([]);
const search = async () => {
  results.value = await getOnpForCompany();
  loading.value = false;
}
search();
const openRecord = async (record: ONPRecord) => {
  isOpen.value = true;
  setTimeout(() => {
    dialog.value?.setOpen(true);
  }, 100);
  await navigateTo({path: `/per-aziende/record-${record.id}`})

}
const {params} = useRoute();
onMounted(async () => {
  // Se è presente un id nella route apro il record
  if (params.id) {
    await openRecord({id: params.id});
  }
})

</script>